import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PageIntro, ProseSections, useTranslatedList, type ProseSection } from './shared';

export function HowItWorks() {
  const { t } = useTranslation();
  const sections = useTranslatedList<ProseSection>('public.howItWorks.sections');
  return (
    <div className="prose">
      <PageIntro title={t('public.howItWorks.title')} lead={t('public.howItWorks.lead')} />
      <ProseSections sections={sections} idPrefix="how" />
      <div className="landing-cta-row">
        <Link to="/sample" className="btn btn-primary">{t('public.landing.ctaPrimary')}</Link>
        <Link to="/signup" className="btn btn-secondary">{t('public.landing.ctaSecondary')}</Link>
      </div>
    </div>
  );
}
